import React from 'react';
import Title from '../../../../Title';

const BankSectionTitle = ({ i18n }) => (
  <React.Fragment>
    <Title text={i18n('onboarding.bankDetails.title')} className="form__title" />
    <div className="mb-3 mb-sm-4">
      <div className="mb-0">{i18n('onboarding.bankDetails.subTitle1')}</div>
      <div className="mb-0">{i18n('onboarding.bankDetails.subTitle2')}</div>
    </div>
  </React.Fragment>
);

export default BankSectionTitle;



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/BankInstructions/BankSectionTitle.js